import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import Scrollable from "@components/ui/Scrollable";
import IndexHashtagList from "./HashtagList";
import {gsap} from "gsap";
import ViewportRoot from "@ts/sframe/ViewportRoot";

export default class IndexPromoteImage extends ComponentBase
{
  constructor(elem: ComponentElem)
  {
    super(elem);
  }
}